// extracted by mini-css-extract-plugin
export default {"header":"Menu_header__vtcKr","navegacao":"Menu_navegacao__iq-YB","marca":"Menu_marca__EG0so","links":"Menu_links__ck3bj","contato":"Menu_contato__pOPHQ","pular":"Menu_pular__n2mKj"};